<template>

    <div class="row">
        <div class="col s12 m9 l9">
            <ul class="pagination">
                <li @click="changePage(1)" :disabled="currentPage === 1"><a href="#!"><i
                            class="material-icons">first_page</i></a></li>
                <li @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><a href="#!"><i
                            class="material-icons">chevron_left</i></a></li>

                <li v-for="page in visiblePageNumbers" :key="page" @click="changePage(page)"
                    :class="{ active: page === currentPage }">
                    <a href="#!"> {{ page }}</a>
                </li>

                <li @click="changePage(totalPages)" :disabled="currentPage === totalPages"><a href="#!"><i
                            class="material-icons">chevron_right</i></a></li>
                <li @click="changePage(totalPages)" :disabled="currentPage === totalPages"><a href="#!"><i
                            class="material-icons">last_page</i></a></li>
            </ul>
        </div>

        <div class="col s12 m3 l3">
            <div class="input-field">
                <select class="icons" v-model="itemsPerPageInternal" @change="emitChange" id="event_list">
                    <option :value="10">10 {{strPag}}</option>
                    <option :value="20">20 {{strPag}}</option>
                    <option :value="50">50 {{strPag}}</option>
                    <option :value="100">100 {{strPag}}</option>
                </select>
                <label>{{strPerPag}}</label>
            </div>

        </div>
    </div>

</template>

<script>

import M from 'materialize-css'

export default {
  // Le "props" sono i dati che questo componente riceve dal componente padre (ListEventPage.vue)
  props: {
    strPerPag: {
      type: String,
      required: true

    },
    strPag: {
      type: String,
      required: true

    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 9 // Valore di default, deve corrispondere a quello in ListEventPage
    },
    maxVisibleButtons: {
      type: Number,
      default: 5 // Quanti bottoni numerici di pagina mostrare contemporaneamente (es. 1 2 [3] 4 5)
    }
  },
  data () {
    return {
      // itemsPerPageInternal è usato per il v-model del select.
      // È una copia del prop itemsPerPage per evitare di modificare direttamente un prop.
      itemsPerPageInternal: this.itemsPerPage
      // translationStore: translationStore
    }
  },

  computed: {
    // Questa computed property calcola quali numeri di pagina mostrare nel controllo
    // per non avere una miriade di bottoni se ci sono centinaia di pagine.
    visiblePageNumbers () {
      const range = []
      const half = Math.floor(this.maxVisibleButtons / 2)
      let startPage = Math.max(1, this.currentPage - half)
      const endPage = Math.min(this.totalPages, startPage + this.maxVisibleButtons - 1)

      // Assicura che, se siamo verso la fine, mostriamo sempre il numero massimo di bottoni
      if (endPage - startPage + 1 < this.maxVisibleButtons) {
        startPage = Math.max(1, endPage - this.maxVisibleButtons + 1)
      }

      for (let i = startPage; i <= endPage; i++) {
        range.push(i)
      }
      return range
    }
  },
  watch: {
    // Osserva il prop itemsPerPage per aggiornare itemsPerPageInternal
    itemsPerPage: {
      immediate: true, // Esegui la funzione handler immediatamente all'avvio
      handler (newValue) {
        this.itemsPerPageInternal = newValue
      }
    }
  },
  methods: {

    initMaterializeForms () {
      this.$nextTick(() => {
        // Inizializza/Aggiorna le select
        const selectElements = this.$el.querySelectorAll('select')

        if (M && M.FormSelect) {
          selectElements.forEach(selectEl => {
            // Distruggi l'istanza esistente prima di inizializzare per prevenire problemi
            if (selectEl.M_FormSelect) {
              selectEl.M_FormSelect.destroy()
            }
            // Inizializza la select
            M.FormSelect.init(selectEl, {
              classes: 'icon-flags-select' // Questa classe verrà applicata al contenitore della select
            })

            // Assicurati che Materialize re-renderizzi la select se il valore è già impostato
            // A volte è necessario un ulteriore $nextTick per assicurare che Materialize abbia finito il suo rendering
            if (selectEl.value && selectEl.M_FormSelect) {
              this.$nextTick(() => {
                selectEl.M_FormSelect.input.value = selectEl.options[selectEl.selectedIndex].textContent
                // Materialize Select può richiedere un "force update" visivo
                // Questi sono tentativi per forzarlo, prova a toglierli se funziona senza
                // selectEl.M_FormSelect.input.click();
                // selectEl.M_FormSelect.input.focus();
              })
            }
          })
        }
      })
    },

    // Emette l'evento 'page-changed' al componente padre quando un bottone di pagina viene cliccato
    changePage (page) {
      // Controlla che la pagina sia valida e diversa dalla corrente per evitare chiamate inutili
      if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
        this.$emit('page-changed', page)
      }
    },
    // Emette l'evento 'items-per-page-changed' quando il valore del select cambia
    emitChange () {
      this.$emit('items-per-page-changed', this.itemsPerPageInternal)
      // NON è necessario emettere 'page-changed', 1 qui.
      // La logica di tornare alla prima pagina (currentPage = 1) quando cambia itemsPerPage
      // è gestita nel componente padre (ListEventPage.vue), il che è una buona separazione delle responsabilità.
    }
  },
  mounted () {
    this.initMaterializeForms()
  },
  updated () {
    // Re-inizializza il select di MaterializeCSS ogni volta che il DOM del componente viene aggiornato.
    // Questo è cruciale perché Materialize a volte ricostruisce l'elemento select.
    this.initMaterializeForms()
  }
}
</script>

<style scoped>
.pagination-controls {
    display: flex;
    justify-content: center;
    /* Centra i controlli orizzontalmente */
    align-items: center;
    /* Allinea verticalmente gli elementi */
    gap: 10px;
    /* Spazio tra i bottoni e il select */
    margin-top: 30px;
    /* Spazio sopra i controlli */
    margin-bottom: 20px;
    /* Spazio sotto i controlli */
    flex-wrap: wrap;
    /* Permette ai controlli di andare a capo su schermi piccoli */
}

.pagination-controls button {
    background-color: #007bff;
    /* Colore blu primario (Materialize blue-grey?) */
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 15px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    /* Effetto hover */
    min-width: 50px;
    /* Larghezza minima per i bottoni */
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    /* Stile Materialize */
}

.pagination-controls button:hover:not(:disabled) {
    background-color: #0056b3;
    /* Colore più scuro all'hover */
}

.pagination-controls button:disabled {
    background-color: #cccccc;
    /* Grigio per bottoni disabilitati */
    cursor: not-allowed;
    opacity: 0.7;
    /* Opacità ridotta per disabilitati */
}

.pagination-controls button.active {
    background-color: #0056b3;
    /* Colore per la pagina attiva */
    border: 1px solid #004085;
    font-weight: bold;
}

/* Stili specifici per il select di Materialize */
.pagination-controls .input-field.select-items-per-page {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 15px;
    /* Spazio tra i bottoni e il select */
    min-width: 150px;
    /* Larghezza minima per il select */
}

/* MaterializeCSS tende a nascondere il select nativo, ma la classe browser-default
   dovrebbe aiutare a mantenere il comportamento standard. Se hai problemi di stile,
   potrebbe essere necessario ispezionare il DOM generato da Materialize. */
.pagination-controls select {
    /* Assicurati che il select sia visibile */
    display: block;
    /* Alcuni stili di Materialize potrebbero applicare un margine/padding non voluto */
    margin: 0;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    width: 100%;
    /* Occupa lo spazio disponibile nel suo contenitore */
}

/* Stile per la label del select di Materialize, se visibile */
.pagination-controls .input-field label {
    top: -14px;
    /* Posiziona la label sopra il select */
    font-size: 0.8rem;
    color: #9e9e9e;
}
</style>
